import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "ImmersiveReaderContainer" */ './lazyIndex');
});
// Lazy-load components
export var ImmersiveReaderContainer = createLazyComponent(lazyModule, function (m) { return m.ImmersiveReaderContainer; });
//# sourceMappingURL=index.js.map